import { getDateLocale } from "@utils/localization"
import { formatInTimeZone as _formatInTimeZone } from "date-fns-tz"
import type { FormatOptionsWithTZ } from "date-fns-tz"

/**
 * Wrapper around `date-fns-tz/formatInTimeZone`, overriden to have `options` always contain a `fi`-locale.
 *
 * Should be used over `date-fns-tz/formatInTimeZone`.
 * @param {Date | string | number} date
 * @param {string} timeZone
 * @param {string} formatStr
 * @param {OptionsWithTz?} options - Options to use to override overriden options.
 * @returns {string}
 */

export const formatInTimeZone = (
	date: Date | string | number,
	timeZone: string,
	formatStr: string,
	options: FormatOptionsWithTZ | undefined = undefined
) => _formatInTimeZone(date, timeZone, formatStr, options ?? { locale: getDateLocale() })
